import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardSave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5224 29.7957L14.4986 29.8197L14.4926 29.8269C14.4591 29.8532 14.4347 29.859 14.4217 29.8607C14.4057 29.8628 14.3727 29.863 14.321 29.8376C14.2585 29.7967 14.133 29.638 14.133 29.3785V11.3946C14.133 10.5592 14.6781 10.1334 15.0489 10.1334H24.744C25.1149 10.1334 25.6599 10.5592 25.6599 11.3946V29.3527C25.6599 29.6213 25.5256 29.7818 25.4657 29.8157L25.4353 29.8328L25.4066 29.8525C25.3974 29.8589 25.388 29.8633 25.3806 29.8658C25.3678 29.8633 25.3378 29.8544 25.2969 29.8228L25.2943 29.8197L25.2706 29.7957L20.4659 24.9261L19.8965 24.3489L19.327 24.9261L14.5224 29.7957Z",
			stroke: "url(#paint0_linear_580_99181)",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_580_99181",
			x1: 19.8965,
			y1: 9.33337,
			x2: 19.8965,
			y2: 30.6667,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF699C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FE5763"
			})]
		}) })
	]
});
export default SvgCardSave;
